import { useState } from "react";
import ExpenseItem from "./ExpenseItem";
import ExpenseFilter from "./ExpenseFilter";
import ExpensesChart from "./ExpensesChart";
import "./Expenses.css";

function Expenses(props){ // props as expenses array from parent app.js
    const [year,changeyear]=useState("2020"); // default start year
    
    const expensef=(y)=>{
        changeyear(y); // change current year to paramter year
    }

    let expenses=props.expenses.filter( expense => expense.date.getFullYear().toString() === year ) // Only load those year expenses which are matching to the current year.

    let numItems=<p>No Item is present still in {year}. Add from ☝</p> // default numItems when no items are present.

    if(expenses.length>0){ // if numItems more than 0, we create ExpenseItem for each expense matching this year.
        numItems=expenses.map( expense => <ExpenseItem expenses={expense}/> );
    }

    return (
        <div className="expenses">
            <ExpensesChart expenses={expenses}/>
            <ExpenseFilter expenseyear={year} expensef={expensef}/>
            {numItems}
        </div>
    );
    // in expenseFilter we pass the year selected right now, and expensef to change the year
    // to new selected year.
}

export default Expenses;